import { render, staticRenderFns } from "./VtssInvoices.vue?vue&type=template&id=003859b1&"
import script from "./VtssInvoices.vue?vue&type=script&lang=js&"
export * from "./VtssInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports